import { useMutation } from '@tanstack/react-query';
import { getSubjects } from '../queries/module';
import { useNewSubjectStore } from '../stores/newSubjectStore';

export function useSubject() {
  const setSelectOptions = useNewSubjectStore.getState().setSelectOptions;
  const setSubject = useNewSubjectStore.getState().setSubjects;

  const { isPending, isError, mutate } = useMutation({ 
    mutationKey: ['subject'], 
    mutationFn: (modulo: string) => getSubjects(modulo),
    retry: false,
    onSuccess: (result) => {
      setSubject(result);

      const options: {label:string, value:string}[] = [];
      result.map((it) => options.push({ value: it.slug, label: it.title }));

      setSelectOptions(options)
    }
  });

  return { isPending, isError, mutate };
}
